import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ModalWrapper } from './Library.styles'
import { NavigationRoutes } from '../../Constants/Routes'
import { isAllowChartEnabled, hasDatasetSelectorAccess } from '../../Utility/UserUtils'
import { useCreateToast } from '../../Hooks/useCreateToast'
import ReportingEndpoints from '../../Services/ReportingEndpoints'
import { DropdownButton, DropdownItem, SECONDARY_BUTTON, InfoModal, WARNING_MODAL } from '@mds/mds-reactjs-library'

const getChartRoute = (chartName) => {
  const normalizedChartName = (chartName || '').trim().toLowerCase();
  return normalizedChartName === 'market snapshot'
    ? NavigationRoutes.MARKET_SNAPSHOT
    : NavigationRoutes.VISUALIZE;
};

const LibraryTableActionsColumn = ({summaryEntry, removeReportRequest, editReportNameClicked, datasets = []}) => {
  const navigate = useNavigate();
  const { createErrorToast } = useCreateToast();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSummary, setSelectedSummary] = useState(null);

  const handleDeleteClick = (entry) => {
    setSelectedSummary(entry);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (!selectedSummary) return;

    let removeReportPromises = [];
    let reportRequestIds = [];

    while (selectedSummary.requests.length > 0) {
      let request = selectedSummary.requests.pop();
      reportRequestIds.push(request.reportRequestId);
      removeReportPromises.push(ReportingEndpoints.removeReportRequest(request.reportRequestId));
    }

    Promise.all(removeReportPromises)
      .then(() => {
        removeReportRequest(reportRequestIds);
        setIsModalOpen(false);
      })
      .catch(e => createErrorToast(e));
  };

  // Check if the dataset for this report has DataSelectorAccess permission
  const hasDatasetAccess = () => {
    const dataset = datasets.find(ds => ds.datasetId === summaryEntry.datasetId);
    return hasDatasetSelectorAccess(dataset);
  };

  const reuseDataSelection = (summaryEntry) => {
    ReportingEndpoints
      .getReportRequestById(summaryEntry.reportRequestId)
      .then(({ data }) => {
        const isChart = summaryEntry?.reportTypeName?.toLowerCase() === 'chart' && isAllowChartEnabled()
        const chartRoute = getChartRoute(summaryEntry?.chartName);
        navigate(isChart ? `/${chartRoute}/${summaryEntry.chartName ? summaryEntry.chartName.replace(/\s+/g, "-") : 'Product-level-market-size'}` : `/${NavigationRoutes.DOWNLOAD_DATA}`, { state : data })
      })
      .catch(e => createErrorToast(e));
  }

  return (
    <>
    <DropdownButton label="..." appearance={SECONDARY_BUTTON}>
      <DropdownItem onClick={() => editReportNameClicked(summaryEntry)}>Rename report</DropdownItem>
      {hasDatasetAccess() && (
        <DropdownItem onClick={() => reuseDataSelection(summaryEntry)}>View selection</DropdownItem>
      )}
      <DropdownItem onClick={() => handleDeleteClick(summaryEntry)}>
        <span style={{ color: '#d51f31' }}>Delete report</span>
      </DropdownItem>
    </DropdownButton>
    {isModalOpen && (
      <ModalWrapper>
        <InfoModal
          type={WARNING_MODAL}
          header="Warning"
          body="Are you sure you want to delete this report? This action cannot be undone."
          cancelButton={{
            label: 'Cancel',
            action: () => setIsModalOpen(false),
          }}
          okButton={{
            label: 'Delete',
            action: confirmDelete,
          }}
          onClose={() => setIsModalOpen(false)}
        />
      </ModalWrapper>
    )}
  </>
  )
}

export default LibraryTableActionsColumn
